import { componentProvider } from 'js-component-framework/es';
import ModalDialog from '@/js/ModalDialog';

/**
 * MenuButton component.
 */
class MenuButton {
  /**
   * Start the component
   */
  constructor({ children, element, options }) {
    this.children = children;
    this.element = element;
    this.options = options;

    // Bind class methods.
    this.init = this.init.bind(this);

    this.init();
  }

  /**
   * Set up the ModalDialog.
   */
  init() {
    this.menuButton = new ModalDialog(this.element, this.options);
  }
}

const menuButtonConfig = {
  name: 'menu-button',
  component: MenuButton,
  options: {
    close: '.menu-drawer__close',
    useTransition: true,
  },
};

componentProvider(menuButtonConfig);
